import React, { useState } from 'react';
import './StepTwo.scss'; // Import the new SCSS file

function PropertyStepTwo({ propertyDetails, handleChange, handleSubmit }) {
  const [acceptTerms, setAcceptTerms] = useState(true); // Checkbox is checked by default
  const [emailError, setEmailError] = useState(''); // Track email validation error
  const [showErrors, setShowErrors] = useState(false); // Track form validation errors

  // Email validation function
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // Handle email changes and set email validation errors
  const handleEmailChange = (e) => {
    const { value } = e.target;
    handleChange(e);
    if (!validateEmail(value)) {
      setEmailError('Please enter a valid email address.');
    } else {
      setEmailError('');
    }
  };

  // Validate the entire form
  const isFormValid = () => {
    return (
      propertyDetails.name &&
      propertyDetails.email &&
      propertyDetails.phone &&
      acceptTerms &&
      !emailError
    );
  };

  // Handle form submission and validation errors
  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (isFormValid()) {
      handleSubmit(e); // Call the parent handleSubmit if the form is valid
    } else {
      setShowErrors(true); // Show error borders if form is invalid
    }
  };

  return (
    <div className="property-step-two">
      <form onSubmit={handleFormSubmit}>
      <h1 className="brand-title">Instant Property Valuation</h1>
        {/* Name input with conditional red border */}
        <input
          type="text"
          name="name"
          placeholder="Your name"
          value={propertyDetails.name}
          onChange={handleChange}
          className={`step-two-input ${showErrors && !propertyDetails.name ? 'step-two-error-border' : ''}`}
        />

        {/* Email input with conditional red border */}
        <input
          type="email"
          name="email"
          placeholder="Email"
          value={propertyDetails.email}
          onChange={handleEmailChange}
          className={`step-two-input ${showErrors && (!propertyDetails.email || emailError) ? 'step-two-error-border' : ''}`}
        />

        {/* Phone input with conditional red border */}
        <input
          type="phone"
          name="phone"
          placeholder="Phone Number"
          value={propertyDetails.phone}
          onChange={handleChange}
          className={`step-two-input ${showErrors && !propertyDetails.phone ? 'step-two-error-border' : ''}`}
        />

        {/* Terms and Conditions Checkbox */}
        <div className="step-two-checkbox-group">
          <input
            type="checkbox"
            id="acceptTerms"
            checked={acceptTerms}
            onChange={(e) => setAcceptTerms(e.target.checked)}
          />
          <label htmlFor="acceptTerms">
            I have read and accept
            <a href="/terms" target="_blank" rel="noopener noreferrer"> Terms & Conditions </a>
            &
            <a href="https://www.your-move.co.uk/uploads/asset_file/YM%20Chris%20Stonock.pdf?cache=0f3a9d094aa0162e2a442ce0fa78ab4e" target="_blank" rel="noopener noreferrer"> Privacy Policy</a>.
          </label>
        </div>

        {/* Submit button */}
        <button
          type="submit"
          id='get-online-val-btn'
          className={`step-two-button ${!isFormValid() ? 'disabled-button' : ''}`}
        >
          Get Valuation NOW
        </button>
      </form>
    </div>
  );
}

export default PropertyStepTwo;
